import { render, staticRenderFns } from "./Baidu-map.vue?vue&type=template&id=159cdbf2"
import script from "./Baidu-map.vue?vue&type=script&lang=js"
export * from "./Baidu-map.vue?vue&type=script&lang=js"
import style0 from "./Baidu-map.vue?vue&type=style&index=0&id=159cdbf2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports